import {AppStore} from "../../desktop";
import {Role} from "../../models/Role";
import {RolesActionTypes} from "./types";
import {TabsActionTypes} from "../tabs";

export const actionRoleFetchAll = () => {
	AppStore.dispatch({type: RolesActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionRoleFetchAllCompleted = (roles: Role[]) => {
	AppStore.dispatch({type: RolesActionTypes.FETCH_ALL_COMPLETED, payload: roles})
}

export const actionRoleFetch = (role: Role) => {
	AppStore.dispatch({type: RolesActionTypes.FETCH_ONE_REQUEST, payload: role})
}

export const actionRoleFetchCompleted = (role: Role) => {
	AppStore.dispatch({type: RolesActionTypes.FETCH_ONE_COMPLETED, payload: role})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: role})
}

export const actionRoleSave = (role: Role) => {
	AppStore.dispatch({type: RolesActionTypes.SAVE_REQUEST, payload: role})
}

export const actionRoleSaveCompleted = (role: Role) => {
	AppStore.dispatch({type: RolesActionTypes.SAVE_COMPLETED, payload: role})
}

export const actionRoleDelete = (role: Role) => {
	AppStore.dispatch({type: RolesActionTypes.DELETE_REQUEST, payload: role})
}

export const actionRoleDeleteCompleted = (role: Role) => {
	AppStore.dispatch({type: RolesActionTypes.DELETE_COMPLETED, payload: role})
}

export const actionDeleteRoles = (roles: Role[]) => {
	AppStore.dispatch({type: RolesActionTypes.DELETE_MULTIPLE_REQUEST, payload: roles})
}

export const actionDeleteRolesCompleted = (roles: Role[]) => {
	AppStore.dispatch({type: RolesActionTypes.DELETE_MULTIPLE_COMPLETED, payload: roles})
}